import { User } from '@app/models/user.model';

/**
 * Return an additional field value
 * @param id - id or additional field value
 * @param user - user - current logged in User
 * @returns the user additional field value by given id
 */
export function getAdditionalFieldValue(id: number, user: User): string {
  let additionalFieldValue = '';
  if (user) {
    // eslint-disable-next-line
    if (id && user && user.additionalFields) {
      user.additionalFields.forEach((field) => {
        // NOTE: Allow == type coercion
        // eslint-disable-next-line
        if (field.id == id) {
          additionalFieldValue = field.value;
        }
      });
    }
  }
  return additionalFieldValue;
}
